import Vue from 'vue'
import defaultState from './state'
export default {
  setIsCallingLogin: (state, payload) => { state.isCallingLogin = payload },
  refreshTokenTimer: (state, payload) => { state.refreshTokenTimer = payload },
  authUser: (state, payload) => {
    state.token = payload.token
    state.user = payload.user
  },
  setImpersonatedUser: (state, payload) => { state.impersonatedUser = payload },
  clearAuthData: state => {
    state.token = null
    state.user = {}
    state.refreshTokenTimer = 0
  },
  clearStoreData: state => {
    const initialState = defaultState.getDefaultState()
    Object.keys(initialState).forEach(key => {
      Vue.set(state, key, initialState[key])
    })
  }
}
